<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <br>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-data-table :headers="headers" :items="pay_band_list" class="elevation-1 mytable" :search="search">
      <template v-slot:top>
        <v-toolbar class="toolbar" flat color="white">
          <v-toolbar-title>Pay Band</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row dense>
          <v-col cols="12" sm="3" md="3">
            <v-btn color="success" outlined rounded v-if="pay_band_list.length != 0">
              <download-excel class="mr-2 pb-3 pt-2" :data="pay_band_list" :fields="table_fields"
                worksheet="PayRollPayBand" name="PayRollPayBand.xls">
                <v-icon dark>mdi-file-excel</v-icon> Export
              </download-excel>
            </v-btn>
          </v-col>
          <v-col sm="6" md="4" cols="12">
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
            </v-text-field>
          </v-col>
          <span style="width: 20px"></span>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn color="mb-2 button" v-on="on">Add Pay Band</v-btn>
            </template>
            <v-card>
              <v-form v-model="valid">
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-autocomplete v-if="editedIndex === -1" dense v-model="editedItem.pay_commission"
                          :items="pay_commission_list" label="Pay Commission/Scale" item-text="name" item-value="id"
                          single-line rounded outlined></v-autocomplete>
                        <v-text-field v-else v-model="editedItem.pay_commission_name" label="Pay Commission"
                          :rules="[(v) => !!v || 'required']" rounded outlined dense readonly disabled>
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <v-autocomplete v-if="editedIndex === -1" dense v-model="editedItem.designation"
                          :items="designation_list" label="Designation" item-text="name" item-value="id" single-line
                          rounded outlined></v-autocomplete>
                        <v-text-field v-else v-model="editedItem.designation_name" label="Designation"
                          :rules="[(v) => !!v || 'required']" rounded outlined dense readonly disabled>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-model="editedItem.lower" label="Enter Lower Value"
                          :rules="[(v) => !!v || 'required']" rounded outlined dense type="number">
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-model="editedItem.higher" label="Enter Higher Value"
                          :rules="[(v) => !!v || 'required']" rounded outlined dense type="number">
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-model="editedItem.increment" label="Enter Increment Value" rounded outlined
                          dense type="number">
                        </v-text-field>
                      </v-col>

                      <!-- <v-col cols="12" sm="12" md="12">
                    <v-checkbox v-model="editedItem.isActive" color="success" label="Is Active?"></v-checkbox>
                </v-col> -->
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="mb-2 button" text @click="close">Cancel</v-btn>
                  <v-btn color="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
        </v-row>
      </template>

      <template v-slot:item.isactive="{ item }">
        <span v-if="item.isactive">
          <v-icon small class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
        </span>
        <span v-else>
          <v-icon small class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
        </span>
      </template>

      <template v-slot:item.action="{ item }">
        <div>
          <v-avatar style="" size="25" class="edit-avatar">
            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
          </v-avatar>
        </div>
      </template>
    </v-data-table>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    valid: false,
    // extraBreadcrumbItems: [
    //   { text: "Pay Band", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    overlay: false,
    errorMsg: {
      castId: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    headers: [
      {
        text: "Pay Commission",
        align: "left",
        sortable: false,
        value: "pay_commission_name",
      },
      {
        text: "Designation",
        align: "left",
        sortable: false,
        value: "designation_name",
      },
      {
        text: "Lower Value",
        align: "left",
        sortable: false,
        value: "lower",
      },
      {
        text: "Higher Value",
        align: "left",
        sortable: false,
        value: "higher",
      },
      {
        text: "Increment Value",
        align: "left",
        sortable: false,
        value: "increment",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    table_fields: {
      "Pay Commission": "pay_commission_name",
      Designation: "designation_name",
      "Lower Value": "lower",
      "Higher Value": "higher",
      "Increment Value": "increment",
    },
    pay_band_list: [],
    pay_commission_list: [],
    designation_list: [],
    editedIndex: -1,
    editedItem: {
      payBandId: "",
      higher: "",
      lower: "",
      increment: "",
      pay_commission_id: "",
      pay_commission_name: "",
      designation_id: "",
      designation_name: "",
    },
    defaultItem: {
      payBandId: "",
      higher: "",
      lower: "",
      increment: "",
      pay_commission_id: "",
      pay_commission_name: "",
      designation_id: "",
      designation_name: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Pay Band" : "Edit Pay Band";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    initializeErrorMsgFalse() {
      this.errorMsg.castId = false;
    },

    onLoad() {
      this.overlay = true;
      axios
        .post("/Payroll/getPayBandList")
        .then((res) => {
          if (res.data.msg == "200") {
            if ((this.load = true)) {
              this.overlay = false;
              this.pay_band_list = res.data.pay_band_list;
              //window.alert(JSON.stringify(this.pay_band_list))
              this.pay_commission_list = res.data.pay_commission_list;
              this.designation_list = res.data.designation_list;
            }
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.pay_band_list.indexOf(item);
      this.dialog = true;
      this.editedItem.higher = item.higher;
      this.editedItem.lower = item.lower;
      this.editedItem.increment = item.increment;
      this.editedItem.pay_commission_id = item.pay_commission_id;
      this.editedItem.pay_commission_name = item.pay_commission_name;
      this.editedItem.designation_id = item.designation_id;
      this.editedItem.designation_name = item.designation_name;
      this.editedItem.payBandId = item.id;
      //window.alert(JSON.stringify(this.editedItem))
    },

    // deleteItem (item) {
    //   const index = this.language_super_master_list.indexOf(item)
    //   confirm('Are you sure you want to delete this item?') && this.language_super_master_list.splice(index, 1)
    // },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/Payroll/editPayBand", this.editedItem)
            .then((res) => {
              if (res.data.status.code == "200") {
                //   Object.assign(
                //     this.pay_band_list[this.editedIndex],
                //     this.editedItem
                //   );
                this.showSnackbar(
                  "#4caf50",
                  "Pay Band Updated Successfully..."
                ); // show snackbar on success
                this.onLoad();
              } else if (res.data.status.code == "NA") {
                this.showSnackbar("#b71c1c", "Pay Band Already Present!!!"); // show snackbar on error
              }
            })
            .catch((error) => {
              window.console.log(error);
            });
          this.close();
        }
      } else {
        //window.alert(JSON.stringify(this.editedItem))
        axios
          .post("/Payroll/savePayBand", this.editedItem)
          .then((res) => {
            if (res.data.status.code == "200") {
              this.showSnackbar("#4caf50", "Pay Band Added Successfully..."); // show snackbar on success
              this.onLoad();
            } else if (res.data.status.code == "NA") {
              this.showSnackbar("#b71c1c", "Pay Band Already Present!!!"); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
        this.close();
      }
    }, // end of save()

    isValidated() {
      if (this.editedItem.payBandId) {
        return true;
      } else {
        if (!this.editedItem.payBandId) {
          this.errorMsg.payBandId = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>